import { ActionTree } from "vuex";
import * as types from "@/store/constants/types";
import * as status from "@/store/constants/status";
import Http from "@/api/http/fetch/index";
import {
  login,
  getUserInfoById,
  transferAccount,
  linkAccount,
  getServiceList
} from "@/api/http/gx/gxUser";
import { isIos, isEmpty } from "@/utils/lodash";
import EventBus from "@/utils/eventBus";

export let serviceUnavailable = false;
let requestRetryTimes: number = 0;

export const gxErrorHandler = (error: any) => {
  console.log("gxErrorHandler:", error);
  if (
    error.error &&
    typeof error.error === "object" &&
    error.error.meta &&
    error.error.meta.code === 24003
  ) {
    //黑客干扰 或者 被封：
    serviceUnavailable = true;
  } else if (
    error.error &&
    typeof error.error === "object" &&
    error.error.meta &&
    error.error.meta.code === 10013
  ) {
    //黑客干扰 或者 被封：
    serviceUnavailable = true;
  } else if (
    error.error &&
    typeof error.error === "object" &&
    error.error.meta &&
    error.error.meta.code === 10014
  ) {
    serviceUnavailable = true;
  }
};

export const requestErrorHandle = (
  error: any,
  typesName: any,
  payload: any,
  dispatch: any
) => {
  //request error ,eq: request time out handle>
  console.log("requestErrorHandle:", {
    error,
    typesName,
    payload
  });

  //IOS的:
  if (error && error.error && error.error.NSLocalizedDescription) {
    // "The network connection was lost." code: -1005
    console.log("发现LOGIN_BY_GX请求失败,开始重试", error);
    requestRetryTimes += 1;
    if (requestRetryTimes > 2) {
      console.log("发现LOGIN_BY_GX请求失败,重试超过2次，stop>>>", error);
      requestRetryTimes = 0;
    } else {
      //超过两次不进行重试
      console.log("发现LOGIN_BY_GX请求失败,开始重试,start>>>", error);
      dispatch(typesName, payload);
    }
  }
};

const actions: ActionTree<any, any> = {
  async [types.UPDATE_GX_MASTER_SERVER_DATA](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      let masterId =
        getters[types.GETTER_MASTER_ID] || getters[types.GETTER_DEVICE_ID];
      masterId = masterId.toString();
      const result = await getUserInfoById(masterId);
      console.log("UPDATE_GX_MASTER_SERVER_DATA result:", result);
      dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, result);
    } catch (error) {
      gxErrorHandler(error);
      return Promise.reject(error);
    }
  },

  async [types.CHECK_GX_USER_LOGINED](
    { state, commit, dispatch, getters, rootState },
    payload: any
  ) {
    try {
      const gxUserInfo = getters[types.GETTER_MASTER_SERVICE_DATA];
      if (isEmpty(gxUserInfo)) {
        console.log("发现注册GX失败:");
        const masterId = getters[types.GETTER_DEVICE_ID];
        await dispatch(types.LOGIN_BY_GX, {
          masterId
        });
        return true;
      } else {
        console.log("检查注册GX成功:");
        return true;
      }
    } catch (error) {
      EventBus.$emit("toast-show", {
        type: "warning",
        content: "Sign user failed,please check your network",
        duration: 2000
      });
      return false;
      // return Promise.reject(error);
    }
  },

  async [types.UPDATE_GX_SERVICE_LIST](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const deviceId = getters[types.GETTER_DEVICE_ID];
      const serviceResult = await getServiceList(deviceId);
      commit(types.RECEIVE_GX_SERVICE_LIST, serviceResult);
      await dispatch(types.RECEIVE_SUBS_LIST, serviceResult);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async [types.LOGIN_BY_GX]({ state, commit, dispatch }, payload: any) {
    console.log("执行了loginin");
    try {
      let result: any;
      if (payload.hasOwnProperty("userId")) {
        result = await login(
          payload.masterId.toString(),
          payload.userId.toString()
        );
      } else {
        result = await login(payload.masterId.toString());
      }
      console.log("LOGIN_BY_GX result:", result);
      dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, result);
      dispatch(types.UPDATE_VIP_PACKAGE_PROPERTY, result);
      return result;
    } catch (error) {
      console.log("loginin", error);
      gxErrorHandler(error);
      requestErrorHandle(error, types.LOGIN_BY_GX, payload, dispatch);
      return Promise.reject(error);
    }
  },

  async [types.TRANSFER_ACCOUNT]({ state, commit, dispatch }, payload: any) {
    try {
      const result = await transferAccount(
        payload.userId.toString(),
        payload.deviceId
      );
      console.log(" TRANSFER_ACCOUNT:", result);
      dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, result);
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async [types.LINK_ACCOUNT](
    { state, commit, dispatch, getters },
    payload: any
  ) {
    try {
      const result = await linkAccount(payload);
      console.log(" LINK_ACCOUNT:", result);
      dispatch(types.RECEIVE_GX_MASTER_SERVER_DATA, result);
      //如果link成功，检查是否之前在黑名单里面，去更新状态：
      return result;
    } catch (error) {
      console.log("LINK_ACCOUNT 失败：", error);
      if (
        error.error &&
        typeof error.error === "object" &&
        error.error.meta &&
        error.error.meta.code === 10014
      ) {
        //如果返回的失败是黑名单：
        //将用户的status置为Banned：
        const { userId } = payload; //关联的子账户
        let userStatus = getters[types.GETTER_USER_STATUS_BY_ID](userId);
        if (!userStatus) {
          commit(types.ADD_USER_STATUS, userId);
          userStatus = getters[types.GETTER_USER_STATUS_BY_ID](userId);
        }
        commit(types.UPDATE_USER_STATUS, {
          ...userStatus,
          status: status.BANNED
        });
      }

      return Promise.reject(error);
    }
  },

  async [types.RECEIVE_GX_MASTER_SERVER_DATA](
    { state, commit, dispatch, rootState },
    payload: any
  ) {
    try {
      commit(types.RECEIVE_GX_MASTER_SERVER_DATA, payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [types.ADD_CONNECTED_USER](
    { state, commit, dispatch, rootState },
    payload: any
  ) {
    //比较connection中是否包含了userList没有包含的用户，将其插入
    const { userList, insUserInfoModule, insUserMediaModule } = rootState;
    const { insUserList } = insUserInfoModule;
    const { insUserMediaList } = insUserMediaModule;
    const { connections } = payload;
    if (connections !== undefined && connections.length !== 0) {
      for (const child of connections) {
        const findChild = userList.find((user: any) => {
          return user.userId.toString() === child.user_id.toString();
        });
        if (findChild === undefined) {
          const newUser = {
            userId: parseInt(child.user_id),
            userName: child.username,
            userPic: child.profile_pic_url,
            userType: "login"
          };
          userList.push(newUser);

          const newInsUserInfo = {
            userId: parseInt(child.user_id),
            insUserInfo: {},
            dataStatus: "prepare"
          };
          insUserList.push(newInsUserInfo);

          const newInsMediaInfo = {
            userId: parseInt(child.user_id),
            maxMediaId: null,
            moreAvaliable: false,
            insMediaList: [],
            dataStatus: "prepare"
          };
          insUserMediaList.push(newInsMediaInfo);
        }
      }
    }
  },
  async [types.RECEIVE_SUBS_LIST]({ state, commit, rootState }) {
    // 去重
    const handleList = (originList: any) => {
      const result: any = [];

      for (const item of originList) {
        const exist = result.some(
          (v: any) =>
            v.service_type === item.service_type &&
            v.target_user_id === item.target_user_id &&
            v.auto_renew === item.auto_renew
        );
        const index = result.findIndex(
          (v: any) =>
            v.service_type === item.service_type &&
            v.target_user_id === item.target_user_id &&
            v.auto_renew === item.auto_renew &&
            v.purchase_timestamp < item.purchase_timestamp
        );
        item.expire = item.expiration_timestamp <= new Date().getTime();
        if (!exist) {
          result.push(item);
        } else if (exist && index > -1) {
          result.splice(index, 1, item);
        }
      }
      return result.sort(sortMethod);
    };

    // 排序
    const sortMethod = (obj1: any, obj2: any) => {
      if (obj1.expire === obj2.expire) {
        return obj2.purchase_timestamp - obj1.purchase_timestamp;
      } else {
        return obj2.expiration_timestamp - obj1.expiration_timestamp;
      }
    };

    // 取所有的serviceList列表
    const gxServiceList = state.gxServiceList ? state.gxServiceList : [];

    // 取setting的sku列表
    const likesSetting =
      rootState.settingModule &&
      rootState.settingModule.settingData &&
      rootState.settingModule.settingData.auto_subs_like_offers;
    const followSetting =
      rootState.settingModule &&
      rootState.settingModule.settingData &&
      rootState.settingModule.settingData.auto_subs_follow_offers;
    const settingData = likesSetting.concat(followSetting);

    // 过滤vip
    const list = gxServiceList.filter((v: any) => v.service_type !== "vip");

    const resultList: any = handleList(list);

    //组装sku
    for (const ite of resultList) {
      const sku = settingData.find((v: any) => v.kind === ite.service_type);
      sku && (ite.sku = sku);
      if (isIos()) {
        ite.can_renew = ite.expire;
      } else {
        if (ite.auto_renew && ite.pay_source === "iap" && !ite.expire) {
          await Http.QuerySubscription(ite.sku.iap.product_id).then(
            (result: any) => {
              console.log(result);
              ite.can_renew =
                result &&
                result.purchaseInfo &&
                result.purchaseInfo.purchaseData &&
                !result.purchaseInfo.purchaseData.autoRenewing;
              console.log(ite.can_renew);
            }
          );
        } else {
          ite.can_renew = ite.expire;
        }
      }
    }
    console.log("GETTER_SUBS_LIST: _________", resultList);
    commit(types.RECEIVE_SUBS_LIST, resultList);
  },
  [types.UPDATE_VIP_PACKAGE_PROPERTY]({ state, commit, rootState }, payLoad) {
    if (!payLoad.vip_p_valid_time) {
      commit(types.DELETE_EXTRA_PROPERTY, "vip_p_valid_time");
      commit(types.DELETE_EXTRA_PROPERTY, "vip_p_valid_count");
    }
  }
};

export default actions;
